export default "__VITE_PUBLIC_ASSET__59f9e656__"